<template>
  <div>
    <b-card>
      <div slot="header" v-if="!add && lock">
        License Detail
      </div>
      <div slot="header" v-if="!add && !lock">
        Modify License
      </div>
      <div slot="header" v-if="add && !lock">
        Create License
      </div>

      <b-row>
        <b-col md="6">
          <b-form-group class="text-primary" label="Active Use" label-for="ph_is_use">
            <c-switch color="info" label size="lg" id="ph_is_use" v-model="model.is_use" :disabled="lock" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="lock">
        <b-col md="12">
          <b-form-group class="text-primary">
            <label>LicenseKey
              <span class="ml-2" style="cursor:pointer;" v-clipboard:copy="model.license" v-clipboard:success="() => $toastr.s('copied')" v-clipboard:error="() => $toastr.s('copy failed')">
                <i class="fa fa-copy" style="font-size:20px;color:red"></i>
              </span>
            </label>
            <b-textarea type="text" v-model="model.license" :plaintext="lock" rows="4"></b-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="2"> Last Verified </b-col>
        <b-col md="4">
          {{  model.updated_at | datetime  }}
        </b-col>
        <b-col md="2">  </b-col>
        <b-col md="4">

        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="2"> Site </b-col>
        <b-col md="4">
          <b-input type="text" v-model="model.site" :plaintext="lock"></b-input>
        </b-col>
        <b-col md="2"> Company </b-col>
        <b-col md="4">
          <b-input type="text" v-model="model.company" v-if="add" maxlength="16" :formatter="formatter" placeholder="회사 영문명 16자리"></b-input>
          <b-input type="text" v-else :value="model.company" plaintext></b-input>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="2"> Expire </b-col>
        <b-col md="4">
          <date-picker v-if="!lock" v-model="model.expire" type="datetime" class="mb-2"></date-picker>
          <b-input v-if="lock" type="datetime" v-bind:value="model.expire | datetime" plaintext></b-input>
        </b-col>
        <b-col md="2"> onPremise </b-col>
        <b-col md="1">
          <c-switch color="info" label size="lg" v-model="model.onPremise" :disabled="lock" />
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="2"> Group </b-col>
        <b-col md="1">
          <c-switch color="info" label size="lg" v-model="model.Group.use" :disabled="lock" />
        </b-col>
        <b-col md="3">
          <b-input type="text" v-model="model.Group.qty" :plaintext="lock"></b-input>
        </b-col>
        <b-col md="2"> User </b-col>
        <b-col md="1">
          <c-switch color="info" label size="lg" v-model="model.User.use" :disabled="lock" />
        </b-col>
        <b-col md="3">
          <b-input type="text" v-model="model.User.qty" :plaintext="lock"></b-input>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="2"> WSFinder </b-col>
        <b-col md="1">
          <c-switch color="info" label size="lg" v-model="model.WSFinder.use" :disabled="lock" />
        </b-col>
        <b-col md="3">
          <b-input type="text" v-model="model.WSFinder.qty" :plaintext="lock"></b-input>
        </b-col>
        <b-col md="2"> WEBCastle </b-col>
        <b-col md="1">
          <c-switch color="info" label size="lg" v-model="model.WEBCastle.use" :disabled="lock" />
        </b-col>
        <b-col md="3">
          <b-input type="text" v-model="model.WEBCastle.qty" :plaintext="lock"></b-input>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="2"> WMDS </b-col>
        <b-col md="1">
          <c-switch color="info" label size="lg" v-model="model.WMDS.use" :disabled="lock" />
        </b-col>
        <b-col md="3">
          <b-input type="text" v-model="model.WMDS.qty" :plaintext="lock"></b-input>
        </b-col>
        <b-col md="2"> CCE </b-col>
        <b-col md="1">
          <c-switch color="info" label size="lg" v-model="model.CCE.use" :disabled="lock" />
        </b-col>
        <b-col md="3">
          <b-input type="text" v-model="model.CCE.qty" :plaintext="lock"></b-input>
        </b-col>
      </b-row>
      <hr>

      <b-row class="text-center h6 font-weight-bold">
        <b-col md="12"> Status </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="3"> Group </b-col>
        <b-col md="3">
          <b-input type="text" v-model="model.group_status.enable" :plaintext="true"></b-input>
        </b-col>
        <b-col md="3"> User </b-col>
        <b-col md="3">
          <b-input type="text" v-model="model.user_status.enable" :plaintext="true"></b-input>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="3"> WSFinder </b-col>
        <b-col md="3">
          <b-input type="text" v-model="model.wsfinder_status.enable" :plaintext="true"></b-input>
        </b-col>
        <b-col md="3"> WEBCastle </b-col>
        <b-col md="3">
          <b-input type="text" v-model="model.webcastle_status.enable" :plaintext="true"></b-input>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="3"> WMDS </b-col>
        <b-col md="3">
          <b-input type="text" v-model="model.wmds_status.enable" :plaintext="true"></b-input>
        </b-col>
        <b-col md="3"> CCE </b-col>
        <b-col md="3">
          <b-input type="text" v-model="model.cce_status.enable" :plaintext="true"></b-input>
        </b-col>
      </b-row>
      <hr>

      <b-button size="sm" variant="light" @click="back"> Back </b-button>
      <template v-if="lock">
        <div class="float-right">
          <b-button class= "mr-1" size="sm" variant="primary" @click="edit"> Modify </b-button>
          <b-button size="sm" variant="danger" @click="confirm = true"> Delete </b-button>
        </div>
      </template>
      <template v-else>
        <div class="float-right">
          <b-button class="mr-1" size="sm" variant="danger" @click="cancel"> Cancel </b-button>
          <b-button size="sm" variant="primary" @click="save"> Save </b-button>
        </div>
      </template>
    </b-card>
    <b-modal title="Confirm - Delete user account" class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      Deleted data cannot be reversed. Are you sure?
    </b-modal>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import { api, auth } from '@/f1/service';
import reg from '@/f1/reg'
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import 'vue-select/dist/vue-select.css';

const default_model = () => ({
  is_use: true,
  WEBCastle : { qty: 1000, use: true },
  WMDS : { qty: 1000, use: true },
  WSFinder : { qty: 1000, use: true },
  CCE : { qty: 1000, use: true },
  Group : { qty: 100, use: true },
  User : { qty: 100, use: true },
  onPremise: true,
  expire : moment().add(1, 'y').toDate(),

  // status
  wmds_status : { enable : 0, disable : 0 },
  wsfinder_status : { enable : 0, disable : 0 },
  webcastle_status : { enable : 0, disable : 0 },
  cce_status : { enable : 0, disable : 0 },
  group_status : { enable : 0, disable : 0 },
  user_status : { enable : 0, disable : 0 },

});

export default {
  components: { cSwitch, vSelect, DatePicker, moment },
  data : () => ({
      confirm: false,
      add: false,
      lock: true,
      model : default_model(),
      profile: auth.profile,
  }),
  computed: {
    last_info() { return `${this.$options.filters.sdate(this.model.last_visit)} @ ${this.model.last_addr}`; }
  },
  methods: {
    formatter(value){ return value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '' ); },
    cancel() { this.$router.replace({ name: 'uwss_license', params: { id: this.model.id }}); },
    edit() { this.$router.replace({ name: 'uwss_license', params: { id: this.model.id, tag: 'edit' }}); },
    async remove() {
      try {
        await api.uwss.license.delete(this.model.id);
        this.$emit('refresh'); this.$toastr.s('License deleted.'); this.list();
      } catch(e) { this.$toastr.e(e.data || e); this.list(); }
    },
    back() { this.$router.go(-1); },
    list() { this.$router.push({ name: 'uwss_license'}); },
    regex_valid: (c, f = '') => {
      if(!c) { return false }
      try { new RegExp(c, f); return true } catch(e) { return false }
    },
    async save() {
      try {
        if(!(this.model.site || '').trim()) { return this.$toastr.e('Site required.'); }
        if(!(this.model.company || '').trim()) { return this.$toastr.e('Company required.'); }
        if(!(this.model.expire || '')) { return this.$toastr.e('Expire required.'); }
        if(this.model.id) {
          await api.uwss.license.update(this.model);
        }
        else {
          this.model.id = +(await api.uwss.license.add(this.model));
        }
        this.$toastr.s('Done.'); this.$emit('refresh'); this.cancel();
      } catch(e) { this.$toastr.e(e.data || e); this.cancel(); }
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      console.log('[vue] license.detail', 'load item', id);

      if(id === 'add') { this.add = true; this.lock = false; this.model = default_model(); return; }
      else { this.add = false; }

      this.lock = (tag !== 'edit');
      try {
        this.model = Object.assign({}, this.model, await api.uwss.license.get(id));
        this.model.expire = new Date(this.model.expire);
        this.model.license = this.model.license_key + '.' + this.model.license_data;
      }
      catch(e) { console.log(e); this.$toastr.e(e.data || e); this.list(); }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params); console.log(from) } },
  created() { },
  destroyed() { },
  mounted() {
    this.get(this.$route.params);
  }
}
</script>
